 // Basculer entre le mode clair et sombre
import {useState, useEffect} from 'react';
 
const DarkModeToggle = () => {
    const [isDarkMode, setIsDarkMode] = useState(false);
 
    useEffect(() => {
        // Vérifier la préférence de l'utilisateur dans localStorage
        const darkModePreference = localStorage.getItem('darkMode');
        if (darkModePreference === 'enabled') {
            setIsDarkMode(true);
            document.body.classList.add('dark-mode');
        }
    }, []);
    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add('dark-mode');
            localStorage.setItem('darkMode', 'enabled');
        } else {
            document.body.classList.remove('dark-mode');
            localStorage.setItem('darkMode', 'disabled');
        }
    }, [isDarkMode]);
    
        const toggleDarkMode = () => {
            setIsDarkMode(!isDarkMode);
        };
        return (
            <div className={`dark-mode-toggle ${isDarkMode ? 'active' : ''}`} onClick={toggleDarkMode}>
                <div className="slider"></div>
            </div> 
        );
};

export default DarkModeToggle;